
import React, { useState } from "react";
import {
    Box,
    Flex,
    Heading,
    useColorModeValue,
    Text,
    Img,
} from "@chakra-ui/react";
import CenteredAuth from "layouts/auth/types/Centered";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import CInput from "components/CInput";
import CButton from "components/CButton";

function ResetPassword() {
    const { toast, resetPassword, setIsValidSystemConfiguration } = useAuth()

    const [validated, setValidated] = useState(false);
    const [credential, setCredential] = useState({
        password: "",
        confirmPassword: ""
    });

    const navigate = useNavigate()
    const params = useParams();

    const textColor = useColorModeValue("navy.700", "white");
    const textColorSecondary = "gray.400";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setValidated(true);

        if (!credential.password || credential.password.length < 8 || !credential.confirmPassword || credential.confirmPassword.length < 8) return;

        try {
            if (credential.password !== credential.confirmPassword) {
                toast({ title: 'Password and Confirm Password does not match.', position: 'top', status: 'error', isClosable: true });
                return;
            } else {
                const data = await resetPassword(params?.token, credential.password)
                if (!data.error) {
                    if (data.data.role === 'member') {
                        localStorage.removeItem("configuration");
                        setIsValidSystemConfiguration(false);
                    }
                    navigate("/")
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <CenteredAuth
            image={"linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"}
            cardTop={{ base: "140px", md: "14vh" }}
            cardBottom={{ base: "50px", lg: "auto" }}>
            <Flex
                w='100%'
                maxW='max-content'
                me='auto'
                h='100%'
                alignItems='start'
                justifyContent='center'
                px={{ base: "25px", md: "0px" }}
                flexDirection='column'>
                <Flex
                    flexDirection="column"
                    justifyContent="center"
                    w={{ base: '100%', md: '420px' }}
                >
                    <Img
                        src='/logo8.png'
                        h='auto'
                        w="215px"
                        px='20px'
                        mb="32px"
                        alignSelf="center"
                    />
                </Flex>
                <Box me='auto' mb='34px'>
                    <Heading
                        color={textColor}
                        fontSize={{ base: "3xl", md: "36px" }}
                        mb='16px'>
                        Reset Your Password
                    </Heading>
                    <Text
                        color={textColorSecondary}
                        fontSize='md'
                        w={{ base: "100%", lg: "456px" }}
                        maxW='100%'>
                        Please enter your new password and confirm it to reset your
                        credentials.
                    </Text>
                </Box>
                <Flex
                    zIndex="2"
                    direction="column"
                    w="100%"
                    background="transparent"
                    borderRadius="15px"
                    mx={{ base: 'auto', lg: 'unset' }}
                    me="auto"
                    mb={{ base: '20px', md: 'auto' }}
                >
                    <form onSubmit={handleSubmit}>
                        <CInput
                            label="Password"
                            type="password"
                            value={credential.password}
                            onChange={(value) => setCredential({ ...credential, password: value })}
                            required={true}
                            validated={validated}
                            validationRules={{ minLength: 8 }}
                            placeholder="Min. 8 characters"
                        />
                        <CInput
                            label="Confirm Password"
                            type="password"
                            value={credential.confirmPassword}
                            onChange={(value) => setCredential({ ...credential, confirmPassword: value })}
                            required={true}
                            validated={validated}
                            validationRules={{ minLength: 8 }}
                            placeholder="Min. 8 characters"
                        />
                        <CButton
                            type="submit"
                            mb='24px'>
                            Submit
                        </CButton>
                    </form>
                </Flex>
            </Flex>
        </CenteredAuth>
    );
}

export default ResetPassword;
